module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2z"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "id": "abb"
    }
  }), _vm._v("TRANSLATIONS AND ABBREVIATIONS")]), _vm._v(" "), _c('p', {
    staticClass: "centerx"
  }, [_c('em', [_vm._v("Unless otherwise noted, translations are my own")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Works by Mendelssohn")]), _vm._v(" "), _c('table', {
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "35%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "65%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  }, [_c('em', [_vm._v("Bi’ur")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1t"
  }, [_c('em', [_vm._v("Sefer Netivot Hashalom")]), _vm._v(" ("), _c('em', [_vm._v("The Book of the Paths of Peace")]), _vm._v(", often referred to as the "), _c('em', [_vm._v("Bi’ur")]), _vm._v(" or "), _c('em', [_vm._v("Elucidation")]), _vm._v("). The Hebrew commentary on and German translation of the Pentateuch appear in "), _c('em', [_vm._v("JubA")]), _vm._v(", volumes 15.2–18.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("BMH")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_vm._v("Bi’ur Milot Hahigayon")]), _vm._v(" ("), _c('em', [_vm._v("Elucidation of Logical Terms")]), _vm._v("). The Hebrew appears in "), _c('em', [_vm._v("JubA")]), _vm._v(", 14:23–119.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("Gegenbetrachtungen")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_vm._v("Gegenbetrachtungen über Bonnets Palingenesie")]), _vm._v(" ("), _c('em', [_vm._v("Counterreflections on Bonnet’s Palingenesis")]), _vm._v("). The German appears in "), _c('em', [_vm._v("JubA")]), _vm._v(", 7:65–107.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("HLMK")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_vm._v("Hakdama Lemegilat Kohelet")]), _vm._v(" ("), _c('em', [_vm._v("Introduction to Commentary on the Book of Ecclesiastes")]), _vm._v("). The Hebrew appears in "), _c('em', [_vm._v("JubA")]), _vm._v(", 14:147–160.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("Jerusalem")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_vm._v("Jerusalem, or on Religious Power and Judaism")]), _vm._v(". Translated by Allan Arkush. Hanover, NH: University Press of New England, 1983. The German appears in "), _c('em', [_vm._v("JubA")]), _vm._v(", 8:99–204.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("References appear as "), _c('em', [_vm._v("Jerusalem")]), _vm._v(", English page/German page.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('em', [_vm._v("JubA")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_vm._v("Gesammelte Schriften Jubiläumsausgabe")]), _vm._v(". Edited by Ismar Elbogen, Fritz Bamberger, Alexander Altmann et al. 24 vols. Stuttgart-Bad Cannstatt: F. Frommann, 1971–.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("Morgenstunden")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_vm._v("Morgenstunden, oder Vorlesungen über das Daseyn Gottes")]), _vm._v(" ("), _c('em', [_vm._v("Morning Hours, or Lectures on the Existence of God")]), _vm._v("). The German appears in "), _c('em', [_vm._v("JubA")]), _vm._v(", 3.2:1–175.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("OL")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_vm._v("Or Lanetiva")]), _vm._v(" ("), _c('em', [_vm._v("Light for the Path")]), _vm._v(", the introduction to the "), _c('em', [_vm._v("Bi’ur")]), _vm._v("). The Hebrew appears in "), _c('em', [_vm._v("JubA")]), _vm._v(", 14:209–268.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("“On Evidence”")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("“On Evidence in Metaphysical Sciences.” In "), _c('em', [_vm._v("PW")]), _vm._v(", 251–306. The German appears in "), _c('em', [_vm._v("JubA")]), _vm._v(", 2:267–330. References appear as “On Evidence,” English page/German page.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("Phädon")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_vm._v("Phädon, or on the Immortality of the Soul")]), _vm._v(". Translated by Patricia Noble. New York: Peter Lang, 2007. The German appears in "), _c('em', [_vm._v("JubA")]), _vm._v(", 3.1:5–159. References appear as "), _c('em', [_vm._v("Phädon")]), _vm._v(", English page/German page.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("PW")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_vm._v("Philosophical Writings")]), _vm._v(". Translated and edited by Daniel O. Dahlstrom. Cambridge: Cambridge University Press, 1997.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("“Rhapsody”")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("“Rhapsody, or additions to the Letters on Sentiments.” In "), _c('em', [_vm._v("PW")]), _vm._v(", 131–168. The German appears in "), _c('em', [_vm._v("JubA")]), _vm._v(", 1:381–424. References appear as “Rhapsody,” English page/German page.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("Ritualgesetze")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_vm._v("Ritualgesetze der Juden, betreffend Erbschaften, Vormundschaftssachen, Testamente und "), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _vm._v("Ehesachen, in so weit sie das Mein und Dein angehen")]), _vm._v(" ("), _c('em', [_vm._v("Ritual Laws of the Jews Regarding Inheritances, Guardianships, Wills, and Matrimonial Matters, Insofar as They Concern Mine and Thine")]), _vm._v("). The German appears in "), _c('em', [_vm._v("JubA")]), _vm._v(", 7:109–251.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("“To Enlighten”")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("“On the Question: What Does ‘to Enlighten’ Mean?” In "), _c('em', [_vm._v("PW")]), _vm._v(", 311–317. The German appears in "), _c('em', [_vm._v("JubA")]), _vm._v(", 6.1:113–119. References appear as “To Enlighten,” English page/German page.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("Vorrede")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_vm._v("Vorrede zu Manasseh Ben Israels Rettung der Juden")]), _vm._v(" ("), _c('em', [_vm._v("Preface to Manasseh Ben Israel’s Vindication of the Jews)")]), _vm._v(". The German appears in "), _c('em', [_vm._v("JubA")]), _vm._v(", 8:3–25.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("WJCB")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_vm._v("Moses Mendelssohn: Writings on Judaism, Christianity, and the Bible")]), _vm._v(". Translated by Allan Arkush, Curtis Bowman, and Elias Sacks. Edited by Michah Gottlieb. Waltham, MA: Brandeis University Press, 2011.")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Works by Other Authors")]), _vm._v(" "), _c('table', {
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "30%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "70%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  }, [_c('em', [_vm._v("DVRC")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1t"
  }, [_vm._v("Grotius, Hugo. "), _c('em', [_vm._v("De Veritate Religionis Christianae")]), _vm._v(" ("), _c('em', [_vm._v("On the Truth of the Christian Religion")]), _vm._v("). Amsterdam: Elzeviriana, 1669. References appear as "), _c('em', [_vm._v("DVRC")]), _vm._v(", section (page).")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("Guide")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Maimonides, Moses. "), _c('em', [_vm._v("The Guide of the Perplexed")]), _vm._v(". Translated by Shlomo Pines. 2 vols. Chicago: University of Chicago Press, 1963. References appear as "), _c('em', [_vm._v("Guide")]), _vm._v(", part and chapter (volume and page).")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("MR")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Michaelis, Johann David. "), _c('em', [_vm._v("Mosaisches Recht")]), _vm._v(" ("), _c('em', [_vm._v("Mosaic Law")]), _vm._v("). 6 vols. Frankfurt: J. G. Garbe, "), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _vm._v("1775–1800. References appear as "), _c('em', [_vm._v("MR")]), _vm._v(", section (page).")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("“Search”")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Cranz, August Friedrich. “The Search for Light and Right in a Letter to Mr. Moses Mendelssohn, on the Occasion of his Remarkable Preface to Menasseh ben Israel.” In "), _c('em', [_vm._v("WJCB")]), _vm._v(", 55–67. The German appears in "), _c('em', [_vm._v("JubA")]), _vm._v(", 8:73–87. References appear as “Search,” English page/German page.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("SSB")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Leibniz, Gottfried Wilhelm. "), _c('em', [_vm._v("Sämtliche Schriften und Briefe")]), _vm._v(". Edited by Deutsche Akademie der Wissenschaften zu Berlin. Berlin: Akademie-Verlag, 1923–.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("Theodicy")]), _vm._v(", PD")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Leibniz, Gottfried Wilhelm. “Preliminary Dissertation on the Conformity of Faith with Reason.” In "), _c('em', [_vm._v("Theodicy: Essays on the Goodness of God, the Freedom of Man, and the Origin of Evil")]), _vm._v(", 73–122. Translated by E. M. Huggard. Edited by Austin Farrer. La Salle, IL: Open Court, 1985. The French appears in "), _c('em', [_vm._v("Die philosophischen Schriften")]), _vm._v(", 6:49–101. Edited by Carl Immanuel Gerhardt. 7 vols. Hildesheim: Georg Olms, 1960–1961. References appear as "), _c('em', [_vm._v("Theodicy")]), _vm._v(", PD paragraph (English page/French page).")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("TTP")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Spinoza, Baruch. "), _c('em', [_vm._v("Theological-Political Treatise")]), _vm._v(". Translated by Samuel Shirley. 2nd ed. Indianapolis, IN: Hackett, 1998. The Latin appears in "), _c('em', [_vm._v("Opera")]), _vm._v(", 3:1–267. Edited by Carl Gebhardt. 4 vols. Heidelberg: Carl Winter, 1925. References appear as "), _c('em', [_vm._v("TTP")]), _vm._v(", English page/Latin page.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f76d1396","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/trans.vue
// module id = 72
// module chunks = 0